"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.goTrue = void 0;

const goTrue = client => {
  return {
    type: 'goTrue',
    client,
    login: async ({
      email,
      password,
      remember
    }) => client.login(email, password, remember),
    logout: async () => {
      const user = await client.currentUser();
      return user === null || user === void 0 ? void 0 : user.logout();
    },
    signup: async ({
      email,
      password,
      remember
    }) => client.signup(email, password, remember),
    getToken: async () => {
      const user = await client.currentUser();
      return (user === null || user === void 0 ? void 0 : user.jwt()) || null;
    },
    getUserMetadata: async () => client.currentUser()
  };
};

exports.goTrue = goTrue;